import { render, staticRenderFns } from "./McButton.vue?vue&type=template&id=210e84ef&scoped=true&"
import script from "./McButton.vue?vue&type=script&lang=js&"
export * from "./McButton.vue?vue&type=script&lang=js&"
import style0 from "./McButton.vue?vue&type=style&index=0&id=210e84ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e84ef",
  null
  
)

export default component.exports